export const ERole = {
  SYSTEM_MANAGER: 'SYSTEM_MANAGER',
  SYSTEM_STAFF: 'SYSTEM_STAFF',
  TENANT_MANAGER: 'TENANT_MANAGER',
  TENANT_STAFF: 'TENANT_STAFF',
  ACQUIRER_MANAGER: 'ACQUIRER_MANAGER',
  ACQUIRER_STAFF: 'ACQUIRER_STAFF',
  VALUE_ISSUER_MANAGER: 'VALUE_ISSUER_MANAGER',
  VALUE_ISSUER_STAFF: 'VALUE_ISSUER_STAFF',
  WALLET_SERVICE_MANAGER: 'WALLET_SERVICE_MANAGER',
  WALLET_SERVICE_STAFF: 'WALLET_SERVICE_STAFF',
  COMPANY_MANAGER: 'COMPANY_MANAGER',
  COMPANY_STAFF: 'COMPANY_STAFF',
  SHOP_MANAGER: 'SHOP_MANAGER',
  SHOP_STAFF: 'SHOP_STAFF',
  PREMIUM_GIFT_SHOP_MANAGER: 'PREMIUM_GIFT_SHOP_MANAGER',
  ADMIN_USER_MANAGE_TERMINAL: 'ADMIN_USER_MANAGE_TERMINAL',
  SETTLEMENT_TERMINAL: 'SETTLEMENT_TERMINAL',
  CALLER_APP: 'CALLER_APP',
  PREMIUM_GIFT_MANAGER: 'PREMIUM_GIFT_MANAGER',
  PREMIUM_GIFT_STAFF: 'PREMIUM_GIFT_STAFF',
  GIFT_ISSUER_MANAGER: 'GIFT_ISSUER_MANAGER',
  GIFT_ISSUER_STAFF: 'GIFT_ISSUER_STAFF',
} as const;

export type TRole = typeof ERole[keyof typeof ERole];
